class Map {
  constructor() {
    this.mapLocations = drupalSettings.mapLocations;
    this.filterkeyword = document.getElementById('filter-keyword');
    this.filterCategory = document.getElementById('filter-category');
    this.filtersSubmit = document.getElementById('map-filter-submit');
    this.filterMarkers = this.filterMarkers.bind(this);
    //Gallery Images
    this.mapStyle = drupalSettings.map;
  }

  init() {
    this.mapLocations.forEach((location) => this.createLocation(location));
    this.filtersSubmit.addEventListener('click', this.filterMarkers);
  }

  filterMarkers(e) {
    e.preventDefault();

    this.mapLocations.forEach((location) => {
      if (this.keywordFilter(location)
        && this.categoryFilter(location)) {
        location.marker.setMap(map);
      } else {
        location.marker.setMap(null);
      }
    });
  }

  strip(string) {
    return string.toLowerCase().replace(/\s/g, '');
  }

  findWord(word, str) {
    return RegExp('\\b' + word + '\\b').test(str);
  }


  keywordFilter(location) {
    if (this.filterkeyword === null) {
      return true;
    }

    return this.filterkeyword.value === '' || this.findWord(this.filterkeyword.value, location.keywords);
  }

  categoryFilter(location) {
    if (this.filterCategory === null || this.filterCategory.value === '0') {
      return true;
    }
    for (let i = 0; i < location.tags.length; i += 1) {
      if (location.tags[i].tid === this.filterCategory.value) {
        return true;
      }
    }

    return false;
  }


  pinSymbol(color) {
    return {
      path: "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z",
      // path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
      fillColor: color,
      fillOpacity: 1,
      strokeColor: color,
      strokeWeight: 2,
      scale: 2,
    };
  }



  createLocation(location) {
    const infowindow = new google.maps.InfoWindow({
      content: this.createInfoWindow(location),
    });
    // var pinImage = new google.maps.MarkerImage("https://maps.google.com/mapfiles/ms/icons/blue-dot.png");
    const marker = new google.maps.Marker({
      position: {
        lat: parseFloat(location.lat),
        lng: parseFloat(location.lng),
      },
      icon: this.pinSymbol((this.mapStyle.map_pin_color) ? this.mapStyle.map_pin_color : '#009dc8'),
      // icon: pinImage,
      map: map,
      title: location.name,
      // animation: google.maps.Animation.DROP,
    });

    marker.addListener('click', () => {
      infowindow.open(map, marker);
    });

    location.marker = marker;
  }

  generateDirectionsUrl(location) {
    let directionsUrl = 'https://google.com/maps/dir//';
    directionsUrl += location.addr.split(' ').join('+') + ',+';
    directionsUrl += location.city.split(' ').join('+') + ',+';
    directionsUrl += location.state + '+';
    directionsUrl += location.zip;
    directionsUrl += '/@' + location.lat + ',' + location.lng + ',15z';

    return directionsUrl;
  }

  renderTagIcons(tags) {
    return tags.reduce((html, tag) => {
      switch (tag.iconType) {
        case 'icon':
          html += `<div class="pl-3"><i class="${tag.iconValue} fa-3x"></i></div>`;
          return html;
        case 'image':
          html += `<img class="pl-3" src="${tag.iconValue}">`
          return html;
        default:
          return html;
      }
    }, '');
  }

  createInfoWindow(location) {
    return `
      <div class="map-info-window">
        <div class="address-container">
          <h5>${location.name}</h5>
          <p>
            ${location.addr}<br>
            ${location.city}, ${location.state} ${location.zip}
          </p>
        </div>
        <div class="d-flex">
          <div>
            <a style="background-color:#fffff;" class="btn btn-primary btn-sm" target="_blank" href="${this.generateDirectionsUrl(location)}">
              Get Directions &#8227;
            </a>
          </div>
        </div>
      </div>`;
  }
}

export default Map;